import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=79cdb62a&scoped=true&"
import script from "./product_detail.vue?vue&type=script&lang=js&"
export * from "./product_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cdb62a",
  null
  
)

export default component.exports